import React from 'react';

import { styled } from '../../theme';
import ChangePasswordForm from './ChangePasswordForm';

const Container = styled('div')({
    maxWidth: 400,
    margin: '60px auto',
});

type Props = {
    changePassword: (password: string, new_password: string) => void;
    onSuccess: () => void;
};

const ChangePasswordView: React.FC<Props> = ({ onSuccess, changePassword }) => (
    <Container>
        <ChangePasswordForm onSuccess={onSuccess} changePassword={changePassword} />
    </Container>
);

export default ChangePasswordView;
